import userFormSlice from "./userFormSlice"
import dashboardSlice from "./dashboardSlice"
export default { userFormSlice, dashboardSlice } 